import { useState, useEffect } from 'react';
import PixelMascot from '@/components/PixelMascot';
import PixelButton from '@/components/PixelButton';
import { ExternalLink } from 'lucide-react';

const HomePage = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const primaryLinks = [
    {
      label: 'View Chart',
      url: 'https://dexscreener.com/base/0xf9d13667ac638dd9bfd98f0e01c9a3eba395cb310f4504fbb955c2bbdca0ba81',
      icon: <ExternalLink className="w-3 h-3 inline-block ml-1" />
    },
    {
      label: 'View Contract',
      url: 'https://basescan.org/address/0x79cc30667d3af1b883d5dc2551679ac0ba3dbb07',
      icon: <ExternalLink className="w-3 h-3 inline-block ml-1" />
    },
    {
      label: 'Follow on X',
      url: 'https://x.com/X204Base',
      icon: <ExternalLink className="w-3 h-3 inline-block ml-1" />
    }
  ];

  const secondaryLinks = [
    { label: 'Whitepaper', path: '/whitepaper' },
    { label: 'Roadmap', path: '/roadmap' },
    { label: 'Docs', path: '/docs' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Press', path: '/press' }
  ];

  return (
    <div className="min-h-screen bg-pixel-white flex items-center justify-center p-4">
      <div className={`w-full max-w-7xl transition-opacity duration-500 ${mounted ? 'opacity-100' : 'opacity-0'}`}>
        <div className="flex items-start justify-between gap-8">
          
          {/* Left Side - Primary CTAs */}
          <div className="flex flex-col gap-4 pt-32">
            {primaryLinks.map((link, index) => (
              <PixelButton
                key={index}
                variant="primary"
                href={link.url}
                external
              >
                {link.label}
                {link.icon}
              </PixelButton>
            ))}
          </div>

          {/* Center Content */}
          <div className="flex-1 max-w-3xl">
            {/* Mascot */}
            <div className="flex justify-center mb-8">
              <PixelMascot />
            </div>

            {/* Hero Title */}
            <h1 className="text-5xl text-center text-deep-navy mb-6 leading-relaxed font-pixel">
              $X204 No Content
            </h1>

            {/* One-liner */}
            <p className="text-lg text-center text-charcoal mb-10 font-pixel">
              x204: no content. no utility.
              <br />
              just a meme.
            </p>

            {/* How It Works Section */}
            <div className="mb-8">
              <h2 className="text-2xl text-center text-ocean-blue mb-6 font-pixel">
                How It Works
              </h2>
              
              <p className="text-sm text-ocean-blue text-center mb-4 px-4 font-pixel">
                When the server wants "success with no body," it replies HTTP 204 and puts any hints in headers.
              </p>

              {/* Server Response Console */}
              <div className="mb-4 bg-pixel-white border-2 border-ocean-blue p-3 font-mono text-xs text-ocean-blue shadow-pixel">
                <div className="mb-1 text-ocean-blue font-bold">HTTP/1.1 204 No Content</div>
                <div>Cache-Control: no-store</div>
                <div>ETag: "0xDEADBEEF204"</div>
                <div>X-Lore: Intentionally blank.</div>
                <div>Content-Length: 0</div>
              </div>

              <p className="text-sm text-ocean-blue text-center mb-4 px-4 font-pixel">
                The client keeps the current view and, if needed, re-requests or just reads headers:
              </p>

              {/* Client Request Console */}
              <div className="bg-pixel-white border-2 border-ocean-blue p-3 font-mono text-xs text-ocean-blue shadow-pixel">
                <div className="mb-1">GET /whitepaper HTTP/1.1</div>
                <div>Host: x204.xyz</div>
              </div>
            </div>

            {/* Footer hint */}
            <div className="mt-8 text-center">
              <p className="text-pixel-xs text-charcoal opacity-50">
                HTTP Status: 200 OK
              </p>
            </div>
          </div>

          {/* Right Side - Secondary CTAs */}
          <div className="flex flex-col gap-3 pt-32">
            {secondaryLinks.map((link, index) => (
              <PixelButton
                key={index}
                variant="secondary"
                href={link.path}
              >
                {link.label}
              </PixelButton>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomePage;
